var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3"},[_c('b-row',{staticClass:"mb-2"},[_c('b-col',[(_vm.task)?_c('DisputeResolutionFormDetailsBox',{attrs:{"application":_vm.task}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }